module.exports = __webpack_public_path__ + "img/img5.91d2d9d7.svg";